module.exports = __webpack_public_path__ + "static/media/eb-icon.3e01cf64.svg";